// import Vue from 'vue'
import APIBase from './APIBase'

var api = new APIBase('webpush')

api.supportsNotifications = () => 'Notification' in window

api.webPushSubscription = null

api.solicitarPermisosNavegador = async () => {
  window.console.log("subscribirseWebPush>", window.serviceWorker);
  const publicVapidKey =
    "BAXgepkeGwk6o6njAoLCHBZLIrUeW4Pzf6Z0J2FIsbcEpm2jTtkD8riUcZoQ0-sZLUgDx7AcRZu43umN4R5EhNY";

  let urlBase64ToUint8Array = (base64String) => {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };

  window.console.log("waiting for acceptance>", window.serviceWorker);
  try {

    api.webPushSubscription = await window.serviceWorker.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
    });
  } catch (e) {
    window.console.warn('Error obteniendo permisos', e)
    if (Notification.permission === 'denied') {
      window.console.warn('Permission for notifications was denied');
    } else {
      window.console.error('Unable to subscribe to push', e);
    }
    window.console.error(e)
    throw e
  }

  window.console.log("acceptance complete>", api.webPushSubscription);

  return api.webPushSubscription
}


api.createSubscriptor = (ticket) => {

  if (!api.webPushSubscription) {
    window.console.log('Se ha pedido crear un suscriptor sin permisos')
    return
  }

  return api.POST('/subscription', {
    subscriber: api.webPushSubscription,
    alias: ticket.visitorEmail,
    creation_app: "noq",
  })
}


export default api
